var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"ig-cards component row",attrs:{"name":"slide","tag":"div"}},_vm._l((_vm.cards),function(card,index){return _c('div',{key:index,staticClass:"col-xs-6 col-md-4 col-lg-3"},[_c('UiCard',{attrs:{"media":card},on:{"click":_vm.viewImg}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79c46dcf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IgCards.vue
// module id = null
// module chunks = 